import api from "lib/api";
import apiForm from "lib/apiFormData";

export const forgetPassword = async (params = {}) => {
  return await apiForm.post(`/v1/password/forgot`, params);
};

export const resetPassword = async (params = {}) => {
  return await api.post("/v1/password/reset", params);
};

export const changePassword = async (params = {}) => {
  return await api.post("/v1/password/changePassword", params);
};
